import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text } from 'modules/common';

function ErrorLabel({ label, errorClassName, disabled, isText }) {
  return (
    <Text
      type="caption"
      className={cn(
        'text-utility-danger-base rounded-sm',
        {
          // TODO: if needed
          '': disabled,
          'bg-utility-danger-muted p-0.5 px-1.5': !isText,
        },
        errorClassName
      )}
    >
      <span>{label}</span>
      <span className="form-error-badge" />
    </Text>
  );
}

export default ErrorLabel;

ErrorLabel.defaultProps = {
  label: '',
  errorClassName: '',
  disabled: false,
  isText: false,
};

ErrorLabel.propTypes = {
  label: PropTypes.string,
  errorClassName: PropTypes.string,
  disabled: PropTypes.bool,
  isText: PropTypes.bool,
};
